// import React, { useState, useRef, useEffect } from 'react';

// function MultiSelect({ defaultValue = [], label, options = [], multiple = true, onValueChange = (value) => { } }) {
//   const [selectedOptions, setSelectedOptions] = useState(defaultValue);
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef();

//   const isObjectOptions = options.length > 0 && typeof options[0] === 'object';

//   const getOptionId = (option) => (isObjectOptions ? option.id : option);
//   const getOptionLabel = (option) => (isObjectOptions ? option.label : option);

//   const handleChange = (value) => {

//     const id = getOptionId(value);
//     let newSelected = []
//     if (multiple) {
//       newSelected = selectedOptions.includes(id)
//         ? selectedOptions.filter((v) => v !== id)
//         : [...selectedOptions, id];

//       setSelectedOptions(newSelected);
//     } else {
//       newSelected = selectedOptions.includes(id)
//         ? selectedOptions.filter((v) => v == id)
//         : [...selectedOptions, id];
//       setSelectedOptions([id]);
//     }
//     onValueChange(newSelected); // now gets the updated array immediately
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Map selected IDs to labels for display
//   const selectedLabels = options
//     .filter((opt) => selectedOptions.includes(getOptionId(opt)))
//     .map(getOptionLabel);

//   return (
//     <div style={{ width: '100%', position: 'relative' }} ref={dropdownRef}>
//       <label>{label}</label>
//       <div
//         style={{
//           padding: '8px',
//           border: '3px solid #eee',
//           borderRadius: '4px',
//           cursor: 'pointer',
//           backgroundColor: '#fff',
//         }}
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         {selectedLabels.length > 0 ? selectedLabels.join(', ') : 'Select options'}
//       </div>

//       {isOpen && (
//         <div
//           style={{
//             position: 'absolute',
//             zIndex: 10,
//             top: '100%',
//             left: 0,
//             width: '100%',
//             border: '1px solid #ccc',
//             borderRadius: '4px',
//             backgroundColor: '#fff',
//             maxHeight: '150px',
//             overflowY: 'auto',
//             marginTop: '4px',
//           }}
//         >
//           {options.map((option) => {
//             const id = getOptionId(option);
//             const label = getOptionLabel(option);
//             return (
//               <label
//                 key={id}
//                 style={{
//                   display: 'flex',
//                   padding: '8px',
//                   borderBottom: '1px solid #eee',
//                   cursor: 'pointer',
//                 }}
//               >
//                 <div style={{ width: 30 }}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions.includes(id)}
//                     onChange={() => { handleChange(option) }}
//                     style={{ marginRight: '8px' }}
//                   />
//                 </div>
//                 {label}
//               </label>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }

// export default MultiSelect;


import React, { useState, useRef, useEffect } from "react";

function MultiSelect({
  defaultValue = [],
  value,                        // controlled value from outside (edit mode)
  label,
  options = [],
  multiple = true,
  onValueChange = () => { },
  name,
  control,
}) {
  const normalizeItem = (item) => {
    if (item === null || item === undefined) return '';
    if (typeof item === 'object') {
      return item.id !== undefined ? String(item.id) : (item.name !== undefined ? String(item.name) : (item.label !== undefined ? String(item.label) : ''));
    }
    return String(item);
  };

  // Normalize value/defaultValue → always an array internally
  const normalizeToArray = (v) => {
    if (!v && v !== 0) return [];
    if (Array.isArray(v)) return v.map(normalizeItem).filter(Boolean);
    const val = normalizeItem(v);
    return val ? [val] : [];
  };

  const [selectedOptions, setSelectedOptions] = useState(() =>
    normalizeToArray(value ?? defaultValue)
  );
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const dropdownRef = useRef();

  // ── Sync internal state when controlled `value` changes (e.g. edit mode) ──
  useEffect(() => {
    const normalized = normalizeToArray(value);
    if (
      normalized.length !== selectedOptions.length ||
      normalized.some((v, i) => v !== selectedOptions[i])
    ) {
      setSelectedOptions(normalized);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const isObjectOptions =
    options.length > 0 && typeof options[0] === "object";

  const getOptionId = (option) =>
    isObjectOptions ? option.id : option;

  const getOptionLabel = (option) =>
    isObjectOptions ? option.label : option;

  const isSelected = (opt) => {
    const optId = String(getOptionId(opt));
    const optLabel = String(getOptionLabel(opt));
    return selectedOptions.some((s) => {
      const str = String(s);
      return str === optId || str === optLabel;
    });
  };

  // Filter options based on search
  const filteredOptions = options.filter((option) =>
    getOptionLabel(option)
      .toString()
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const handleChange = (value) => {
    const id = getOptionId(value);

    let newSelected = [];

    if (multiple) {
      newSelected = isSelected(value)
        ? selectedOptions.filter((v) => String(v) !== String(id) && String(v) !== String(getOptionLabel(value)))
        : [...selectedOptions, id];

      setSelectedOptions(newSelected);
      onValueChange(newSelected);        // multi → pass array
    } else {
      newSelected = [id];
      setSelectedOptions([id]);
      setIsOpen(false);
      onValueChange(id);                 // single → pass plain string, NOT array
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabels = options
    .filter(isSelected)
    .map(getOptionLabel);

  return (
    <div style={{ width: "100%", position: "relative" }} ref={dropdownRef}>
      <label>{label}</label>

      {/* SELECT BOX */}
      <div
        style={{
          padding: "8px 12px",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: "#fff",
          fontSize: "14px",
          color: "#1e293b",
          minHeight: "38px",
          display: "flex",
          alignItems: "center"
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedLabels.length > 0
          ? selectedLabels.join(", ")
          : "Select options"}
      </div>

      {/* DROPDOWN */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 99999,
            top: "100%",
            left: 0,
            width: "100%",
            border: "1px solid #cbd5e1",
            borderRadius: "8px",
            backgroundColor: "#fff",
            maxHeight: "240px",
            overflowY: "auto",
            marginTop: "6px",
            boxShadow: "0 12px 28px rgba(0, 0, 0, 0.18), 0 4px 10px rgba(0, 0, 0, 0.08)",
          }}
        >
          {/* 🔥 SEARCH BOX */}
          <div style={{ padding: "8px" }}>
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "6px",
                border: "1px solid #ddd",
                borderRadius: "4px",
              }}
              onClick={(e) => e.stopPropagation()} // prevent closing
            />
          </div>

          {/* OPTIONS */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => {
              const id = getOptionId(option);
              const label = getOptionLabel(option);

              return (
                <label
                  key={id}
                  style={{
                    display: "flex",
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ width: 30 }}>
                    <input
                      type="checkbox"
                      checked={isSelected(option)}
                      onChange={() => handleChange(option)}
                    />
                  </div>
                  {label}
                </label>
              );
            })
          ) : (
            <div style={{ padding: "10px", color: "#888" }}>
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MultiSelect;
